import React, { useState } from "react";
import { History } from "lucide-react";
import { api, fileViewUrl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const br = (s) => (s ? String(s).slice(0, 10).split("-").reverse().join("/") : "—");

export function AsoHistory({ employeeId, employeeName }) {
  const [items, setItems] = useState(null);
  const open = async () => {
    const { data } = await api.get(`/medical-records/history/${employeeId}`);
    setItems(data);
  };
  return (
    <>
      <Button variant="ghost" size="icon" className="h-8 w-8" onClick={open} title="Histórico de ASOs" data-testid={`aso-history-btn-${employeeId}`}>
        <History className="h-4 w-4 text-[#134074]" />
      </Button>
      <Dialog open={!!items} onOpenChange={(o) => !o && setItems(null)}>
        <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-[640px]" data-testid="aso-history-dialog">
          <DialogHeader><DialogTitle className="text-[#0B2545]">Histórico de ASOs — {employeeName}</DialogTitle></DialogHeader>
          <div className="divide-y divide-slate-100">
            {(items || []).map((r) => (
              <div key={r.id} className="flex items-center gap-3 py-2.5 text-sm" data-testid={`aso-history-item-${r.id}`}>
                <span className={`min-w-[72px] rounded-md px-2 py-0.5 text-center text-[11px] font-semibold ${r.is_history ? "bg-slate-100 text-slate-500" : "bg-emerald-50 text-emerald-700"}`}>{r.is_history ? "Histórico" : "Atual"}</span>
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-slate-800">{r.exam_type} · {r.result || "—"}</p>
                  <p className="text-xs text-slate-500">Exame {br(r.exam_date)} · Validade {br(r.valid_until)}{r.doctor ? ` · ${r.doctor}` : ""}</p>
                </div>
                {r.document_id && <a href={fileViewUrl(r.document_id)} target="_blank" rel="noreferrer" className="text-xs font-semibold text-[#134074] hover:underline">Ver PDF</a>}
              </div>
            ))}
            {items && !items.length && <p className="py-4 text-center text-sm text-slate-400">Sem registros.</p>}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
